
import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Login from "../pages/login/page";
import Dashboard from "../pages/dashboard/page";
import Profile from "../pages/profile/page";
import Workspace from "../pages/workspace/page";
import ToolDetail from "../pages/tool-detail/page";
import SaleCalendar from '../pages/sale-calendar/page';

// 路由守卫组件
function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const isLoggedIn = localStorage.getItem('isLoggedIn');
  
  if (isLoggedIn !== 'true') {
    return <Navigate to="/login" replace />;
  }
  
  return <>{children}</>;
}

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/dashboard",
    element: (
      <ProtectedRoute>
        <Dashboard />
      </ProtectedRoute>
    ),
  },
  {
    path: "/profile",
    element: (
      <ProtectedRoute>
        <Profile />
      </ProtectedRoute>
    ),
  },
  {
    path: "/workspace",
    element: (
      <ProtectedRoute>
        <Workspace />
      </ProtectedRoute>
    ),
  },
  {
    path: "/tool-detail",
    element: (
      <ProtectedRoute>
        <ToolDetail />
      </ProtectedRoute>
    ),
  },
  {
    path: "/sale-calendar",
    element: (
      <ProtectedRoute>
        <SaleCalendar />
      </ProtectedRoute>
    ),
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
